const megamenuInit = (item: HTMLElement) => {
  const header = document.querySelector('.header');
  const link = item.querySelector('.menu__link');
  const sidebarItems = item.querySelectorAll('.megamenu__sidebar-item');
  const categories = item.querySelectorAll('.megamenu__category');
  const activeCategory = 'megamenu__category--active';
  const activeSidebarItem = 'megamenu__sidebar-item--active';
  const back = item.querySelector('.megamenu__sidebar-item-back');

  link.addEventListener('click', (e: any) => {
    e.preventDefault();
    header.classList.toggle('header--megamenu-active');
    item.classList.toggle('megamenu--active');
  });

  window.addEventListener('click', (e: any) => {
    if (!item.contains(e.target)) {
      item.classList.remove('megamenu--active');
      header.classList.remove('header--megamenu-active');
    }
  });

  back.addEventListener('click', (e) => {
    e.preventDefault();
    item.classList.remove('megamenu--active');
    header.classList.remove('header--megamenu-active');
  });

  sidebarItems.forEach((sidebarItem: any) => {
    sidebarItem.addEventListener('mouseover', (e: any) => {
      e.preventDefault();

      const { target } = e.target.dataset;

      sidebarItems.forEach((sItem) => {
        sItem.classList.remove(activeSidebarItem);
      });

      categories.forEach((category: HTMLElement) => {
        category.classList.remove(activeCategory);
        if (target === category.dataset.id) {
          category.classList.add(activeCategory);
          sidebarItem.classList.add(activeSidebarItem);
        }
      });
    });
  });
};

export default megamenuInit;
